import React, { useEffect } from 'react';
import Hero from './Hero';
import Features from './Features';
import MetricsSection from './MetricsSection';
import ChatbotSection from './ChatbotSection';
import CTASection from './CTASection';
import Footer from './Footer';

const LandingPage = ({ onNavigate }) => {
    useEffect(() => {
        document.documentElement.style.scrollBehavior = 'auto';
        window.scrollTo(0, 0);
        return () => {
            document.documentElement.style.scrollBehavior = 'smooth';
        };
    }, []);

    const scrollToFeatures = () => {
        const featuresSection = document.querySelector('#features-section');
        if (featuresSection) {
            featuresSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="min-h-screen bg-slate-900 text-white overflow-x-hidden">
            <Hero onScrollToFeatures={scrollToFeatures} />
            <MetricsSection />
            <Features />
            <ChatbotSection onNavigate={onNavigate} />
            <CTASection onNavigate={onNavigate} />
            <Footer onNavigate={onNavigate} />
        </div>
    );
};

export default LandingPage;